export class Company {
  id: string;
  applicantName?: string;
  icNumber?: string;
  contactNumber?: string;
  email?: string;
  position?: string;
  companyName?: string;
  ssmNumber?: string;
  address?: string;
  postcode?: string;
  state?: string;
  officeNumber?: string;
  officeEmail?: string;
  recommendedBy?: string

  constructor(
    id: string,
    applicantName?: string,
    icNumber?: string,
    contactNumber?: string,
    email?: string,
    position?: string,
    companyName?: string,
    ssmNumber?: string,
    address?: string,
    postcode?: string,
    state?: string,
    officeNumber?: string,
    officeEmail?: string,
    recommendedBy?: string
  ) {
    this.id = id;
    this.applicantName = applicantName;
    this.icNumber = icNumber;
    this.contactNumber = contactNumber;
    this.email = email;
    this.position = position;
    this.companyName = companyName;
    this.ssmNumber = ssmNumber;
    this.address = address;
    this.postcode = postcode;
    this.state = state;
    this.officeNumber = officeNumber;
    this.officeEmail = officeEmail;
    this.recommendedBy = recommendedBy;
  }
}
